import { SvgXml } from "react-native-svg";

import type { IconProps } from "../types";

const xml = `<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 9H6V11H4V9ZM18 4V18C18 19.1 17.1 20 16 20H2C0.89 20 0 19.1 0 18L0.00999999 4C0.00999999 2.9 0.89 2 2 2H3V0H5V2H13V0H15V2H16C17.1 2 18 2.9 18 4ZM2 6H16V4H2V6ZM16 18V8H2V18H16ZM12 11H14V9H12V11ZM8 11H10V9H8V11Z" fill="white"/>
</svg>`;

export const CalendarWithThreeDotsIcon = ({
  size = 14,
  color = "#fff",
}: IconProps) => {
  return <SvgXml xml={xml} width={size} height={size} fill={color} />;
};
